export default __webpack_public_path__ + "static/logo-3cc0dfda5f198d035112d8f6cd581ea2.svg";